type CardProps = {
  imageUrl: string
  title: string
  description: string
}
export const Card = ({ description, imageUrl, title }: CardProps) => {
  return (
    <div className="flex size-[213px] flex-col gap-y-[12px] bg-[#D9C7B0] px-[15px] py-[20px] font-nunito md:h-[272.5px] md:w-[236.5px] lg:h-[332px] lg:w-[260px] ">
      <img src={imageUrl} className="size-[24px] lg:size-[60px] " />
      <h1 className="text-[16px] font-[700] leading-[19.2px] text-[#000000] md:text-[20px] md:leading-[24px] lg:text-[24px] lg:leading-[28.8px] ">
        {title}
      </h1>
      <p className="text-[12px] font-normal leading-[19.2px] md:text-[14px] md:leading-[22.4px] lg:text-[16px] lg:leading-[25.6px]">
        {description}
      </p>
    </div>
  )
}
